













import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import { MolecularWeight } from '@/types/product/productTypes'

export default defineComponent({
  props: {
    molecularWeight: {
      type: Object as () => MolecularWeight,
      required: false,
      default: undefined,
    },
    observedMolecularWeight: {
      type: String,
      required: false,
      default: undefined,
    },
    productType: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { isEmpty }
  },
})
